import { TypesDropdownOption } from '../TypesDropdown';

export const getOptionsWithoutDuplicates = (
  optionsWithDuplicates: TypesDropdownOption[],
): TypesDropdownOption[] =>
  optionsWithDuplicates.filter((option, i) => {
    const optionsWithSameNameIndices = optionsWithDuplicates
      .filter((_option) => _option.name === option.name)
      .map((optionWithSameName, index) => index);
    const areThereDuplicates = optionsWithSameNameIndices.length > 1;
    return !areThereDuplicates || i === optionsWithSameNameIndices[0];
  });
